import { SET_FACETS_PAGINATION_MODE } from './types'

export const setFacetsPaginationMode = (paginationMode: string) => ({
  type: SET_FACETS_PAGINATION_MODE,
  paginationMode
})
